module.exports = __webpack_public_path__ + "static/BBA-Membership_badge-Off_white-d71fd7b299770e19161ed200d332e22a.png";